"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowProviderResponseEnums = exports.WindowProviderRequestEnums = void 0;
var WindowProviderRequestEnums;
(function (WindowProviderRequestEnums) {
    WindowProviderRequestEnums["signTransactionsRequest"] = "SIGN_TRANSACTIONS_REQUEST";
    WindowProviderRequestEnums["guardTransactionsRequest"] = "GUARD_TRANSACTIONS_REQUEST";
    WindowProviderRequestEnums["signMessageRequest"] = "SIGN_MESSAGE_REQUEST";
    WindowProviderRequestEnums["loginRequest"] = "LOGIN_REQUEST";
    WindowProviderRequestEnums["reloginRequest"] = "RELOGIN_REQUEST";
    WindowProviderRequestEnums["logoutRequest"] = "LOGOUT_REQUEST";
    WindowProviderRequestEnums["cancelAction"] = "CANCEL_ACTION_REQUEST";
    WindowProviderRequestEnums["finalizeHandshakeRequest"] = "FINALIZE_HANDSHAKE_REQUEST";
    WindowProviderRequestEnums["finalizeResetStateRequest"] = "FINALIZE_RESET_STATE_REQUEST";
})(WindowProviderRequestEnums = exports.WindowProviderRequestEnums || (exports.WindowProviderRequestEnums = {}));
var WindowProviderResponseEnums;
(function (WindowProviderResponseEnums) {
    WindowProviderResponseEnums["handshakeResponse"] = "HANDSHAKE_RESPONSE";
    WindowProviderResponseEnums["guardTransactionsResponse"] = "GUARD_TRANSACTIONS_RESPONSE";
    WindowProviderResponseEnums["loginResponse"] = "LOGIN_RESPONSE";
    WindowProviderResponseEnums["reloginResponse"] = "RELOGIN_RESPONSE";
    WindowProviderResponseEnums["disconnectResponse"] = "DISCONNECT_RESPONSE";
    WindowProviderResponseEnums["cancelResponse"] = "CANCEL_RESPONSE";
    WindowProviderResponseEnums["signTransactionsResponse"] = "SIGN_TRANSACTIONS_RESPONSE";
    WindowProviderResponseEnums["signMessageResponse"] = "SIGN_MESSAGE_RESPONSE";
    WindowProviderResponseEnums["noneResponse"] = "NONE_RESPONSE";
    WindowProviderResponseEnums["resetStateResponse"] = "RESET_STATE_RESPONSE";
})(WindowProviderResponseEnums = exports.WindowProviderResponseEnums || (exports.WindowProviderResponseEnums = {}));
//# sourceMappingURL=windowProviderEnums.js.map